import React from 'react';
import styled from 'styled-components';

import { PostShort } from '@/typings/model';
import Pagination from '@/components/Pagination';
import { QUERY_DEFAULT_VALUES } from '@/constants/catalog';
import Posts from '@/modules/Blog/components/Main/components/Posts';

const MainView = () => {
  return (
    <Component>
      <Posts />
    </Component>
  );
};

export default MainView;

const Component = styled.div``;
